import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'

import * as MapSelectors from '../../../map.selectors'
import * as PhaseSelectors from '../../../../Phases/phases.selectors'
import * as MapActions from '../../../map.actions'

import * as TutorialSelectors from '../../../../../Tutorial/tutorial.selectors'

import { Game } from '../../../../../Core'

import * as indicatorsSelectors from '../../../../Indicators/indicators.selectors'

import TileButton from '../TileButton'

class MountainInfo extends React.Component {
  constructor() {
    super()

    this.state = {
      growOutClass: '',
    }
  }

  displayButton(label, icon, action, disabled = false) {
    return <TileButton label={label} icon={icon} action={action} disabled={disabled} />
  }

  closePopup() {
    const { closingAction } = this.props

    this.setState({ growOutClass: 'bounceOut-animation' })
    setTimeout(() => {
      closingAction()
    }, 1000)
  }

  render() {
    const {
      selectedTile,
      removeMountain,
      userMap,
      visitorMap,
      currentPhase,
      userData,
      cursorPos,
      isTutorial,
    } = this.props

    const { growOutClass } = this.state

    let currentRock =
      visitorMap.removedRocks[selectedTile.q + '_' + selectedTile.r] ||
      userMap.removedRocks[selectedTile.q + '_' + selectedTile.r]
    let destroying = currentRock && currentRock.destroying > 0
    let maxCounter = 2
    let currentValue = currentRock ? currentRock.destroying - userData.turn : 0
    let nextState =
      currentValue == 1 ? 'map.buildings.next_state_one_Turn' : 'map.buildings.next_state'
    let mousePadding = 50
    let rockPrice = 100
    let offset = 300 + mousePadding
    let left = cursorPos
      ? cursorPos.x + offset < window.innerWidth
        ? cursorPos.x + mousePadding
        : cursorPos.x / 2
      : 0
    let top =
      cursorPos &&
      (cursorPos.y + offset > window.innerHeight ? cursorPos.y - cursorPos.y / 2 : cursorPos.y)

    let buttonDisabled = !(
      currentPhase == 3 &&
      !visitorMap.mapId &&
      !currentRock &&
      userData.antimatter >= rockPrice
    )
    return (
      <div
        className={`panels ${growOutClass} ${!growOutClass ? 'growIn-animation' : ''} `}
        style={cursorPos ? { position: 'absolute', top: top, left: left } : {}}
      >
        <div className="panels--box contextual">
          <div className="panels--box ">
            <div className="panels--body">
              <div className="panel--context">
                <div className="panel--context__header">
                  <span className="text">
                    <FormattedMessage id="map.mountains.name" />
                  </span>
                  <span className="icon-cross" onClick={() => this.closePopup()}>
                    {' '}
                  </span>
                </div>
                <div className="panel--tabs__container">
                  <div className="panel--background"> </div>
                  <div className="panel--context__info">
                    <div className="panel--content noborder">
                      <div className="panel--content__text">
                        <div className="text">
                          <FormattedMessage id="map.mountains.height" />:{' '}
                          <b>{selectedTile.height.toFixed(2)}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {destroying ? (
                  <React.Fragment>
                    <div className="list--panel__info">
                      <div className="column single">
                        <div className="text">
                          <FormattedMessage id={`map.buildings.destruction`} />
                        </div>
                        <FormattedMessage
                          id={nextState}
                          values={{ currentValue: Math.abs(currentValue), maxValue: maxCounter }}
                        />
                      </div>
                    </div>
                    <div className="orange">
                      <span className="icon-bulldozer"> </span>
                      <span>
                        <FormattedMessage id={`map.buildings.destroying`} />
                      </span>
                    </div>
                  </React.Fragment>
                ) : (
                  !isTutorial && (
                    <div className="list--panel__info">
                      <div className="column">
                        <div className="text">
                          <FormattedMessage id="map.buildings.cost" />
                        </div>
                        <div className="value blue">
                          {rockPrice}
                          <span className="icon-antimateria" />
                        </div>
                      </div>
                      <div className="column">
                        <div className="text">
                          <FormattedMessage id="map.buildings.destruction" />
                        </div>
                        <div className="value">
                          <FormattedMessage id="map.buildings.turn" values={{ turns: 2 }} />
                        </div>
                      </div>
                    </div>
                  )
                )}
                {!destroying && !isTutorial
                  ? this.displayButton(
                      'map.buildings.remove',
                      'icon-bulldozer',
                      () => (buttonDisabled ? null : removeMountain()),
                      buttonDisabled
                    )
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedTile: MapSelectors.getSelectedTile(state),
  currentPhase: PhaseSelectors.getCurrentPhase(state),
  visitorMap: MapSelectors.getVisitorMap(state),
  userMap: MapSelectors.getUserMap(state),
  userData: indicatorsSelectors.getUserData(state),
  cursorPos: Game.selectors.getCursorPosition(state),
  isTutorial: TutorialSelectors.isTutorialMode(state),
})

const mapDispatchToProps = (dispatch) => ({
  removeMountain: bindActionCreators(MapActions.removeMountain, dispatch),
})

MountainInfo.propTypes = {
  isTutorial: PropTypes.bool,
  currentPhase: PropTypes.number,
  closingAction: PropTypes.func,
  visitorMap: PropTypes.object,
  userData: PropTypes.object,
  cursorPos: PropTypes.object,
  userMap: PropTypes.object,
  selectedTile: PropTypes.object,
  removeMountain: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MountainInfo))
